"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Name = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Protocol.Common.Channel';
exports.Name = effect_1.Schema.Literal('alarm', 'command', 'consumable', 'event', 'state', 'telemetry', 'prefs').annotations({
    identifier: `${exports.NAMESPACE}.Name`,
    description: 'One of several possible channels defined in the Culligan Message Protocol',
});
//# sourceMappingURL=channel.js.map